export const BASE_CLASS_PREFIX = "semi-open-platform-forum";